import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationEmployees from 'modules/locations/components/Employees'
import LocationCollection from 'modules/locations/store/collections/locations'
import type Location from 'modules/locations/store/models/Location'

const EmployeesComponent = ({
  children,
  contractVersions,
  loading,
}: React.PropsWithChildren<{ contractVersions: ContractVersions; loading: boolean }>) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { location } = useOutletContext<{ location: Location }>()

  const onAddEmployee = () => {
    return navigate(
      navigation.settings.locations.locationsId.employees.add.fullPath({ id: location.id })
    )
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      variant="narrow"
      widget={
        <Button
          iconName="add"
          onClick={onAddEmployee}
          disabled={LocationCollection.models.length <= 1}
        >
          {i18n.t('settings.timeoff_policies.employees.add_employees')}
        </Button>
      }
    >
      {children}
      <LocationEmployees location={location} contractVersions={contractVersions} />
    </ResponsivePage.Body>
  )
}

export default EmployeesComponent
